<phscw-global-regionsfilter></phscw-global-regionsfilter>
<phscw-global-search></phscw-global-search>
@if (showGlobalNotifications) {
  <phscw-global-notifications></phscw-global-notifications>
}
<phscw-global-help-icon></phscw-global-help-icon>
<phscw-global-accountinfo></phscw-global-accountinfo>
